export default "__VITE_ASSET__62403ba7__"